import { ApiService } from '@/utils/api';

const BASE = '/v1/preferences';

interface PreferencesResponse {
  user_id: string;
  connection_id: string;
  data: Record<string, string>;
}

export async function fetchPreferences(connectionId: string): Promise<Record<string, string>> {
  const res = await ApiService.get<PreferencesResponse>(BASE + '/', {
    params: { connection_id: connectionId },
  });
  return res?.data ?? {};
}

export async function savePreferences(
  connectionId: string,
  patch: Record<string, string>,
): Promise<void> {
  await ApiService.put<PreferencesResponse>(
    BASE + '/',
    { data: patch },
    { params: { connection_id: connectionId } },
  );
}
